import React, {Component, ReactElement} from 'react'
import NatStepComponent, {DIspStepInfo, Step} from '../common/resident/NatStepComponent'
import NatTokenRepo, {RegisterTokenFirstLoginRequest} from '../token/repository/NatTokenRepo'
import NatRoomToResidentRepo from '../roomToResident/repository/NatRoomToResidentRepo'
import {
    Comment,
    ContentsSubTitleInner,
    ContentsSubTitleWrapper,
    TxtBold,
    WideMainContainer,
} from '../../../styledComponents/ContentsArea'
import {
    CenterPlainLinkStyledButton,
    PrimaryStyledButton,
    SmallPlainLinkStyledButton,
} from '../../../styledComponents/Button'
import {Colors, FontSize} from '../../../styledComponents/Constants'

import {
    DisplayBlockDiv,
    DisplayItemInputLabelRequired,
    DisplayItemInputTitleRequired,
    DisplayItemTextInput,
    FieldErrorLabel,
} from '../../../styledComponents/DisplayItem'
import {StyledDiv} from '../../../styledComponents/StyledTypeDefinitions'
import styled from 'styled-components'
import {Accordion, AccordionDetails, AccordionSummary, Box, Typography} from '@mui/material'
import withStyles from '@mui/styles/withStyles'
import {BaseHttpError} from '../../../network/errors/baseHandling/BaseHttpError'
import {Nullable} from '../../../app/TypeHelpers'
import {ErrorResponseBody} from '../../../network/response/ErrorResponseBody'
import {RequestItemError} from '../../../network/response/RequestItemError'
import {Messages} from '../../../Messages'
import {HKConstants} from '../../../HKConstants'
import {NatAsyncCallFunction} from '../../common/util/Natutil'
import {createResidentPage, ResidentPagePropsSet} from '../../../components/shared/hoc/createResidentPage'
import {NatPostTokenFirstLogin} from '../token/repository/NatPostTokenFirstLogin'
import {AGREEMENT_TYPE} from '../../../CodeMaster'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import {BlockSpacer} from '../../../styledComponents/ResponsiveConvenience'
import {Location} from 'react-router-dom'

interface FirstLoginLocationState {
    firstLoginReferrerId: string
    dIspStepInfo: DIspStepInfo
    policyAgreeType: string
    authenticationKey: string
    referenceId: string
    mailAddress: string
    familyName: string
    firstName: string
    familyNameKana: string
    firstNameKana: string
}

interface FieldsError {
    mailAddress: Error[]
    mailAddressConfirm: Error[]
}

interface Error {
    message: string
    hasError: boolean
}

type Field = 'mailAddress' | 'mailAddressConfirm';

interface Props {
    tokenRepo: NatTokenRepo,
    roomToResidentRepo: NatRoomToResidentRepo,
    location: Location<FirstLoginLocationState>
}

interface States {
    mailAddress: string
    mailAddressConfirm: string
    registerMailButtonflg: boolean,
    fieldsError: Partial<FieldsError>,
    duplicateError: boolean
    isLoadCompleted: boolean
}


class NatResidentFirstLoginMailAddressRegisterPage extends Component<Props & ResidentPagePropsSet, States> {
    firstLoginLocationState: FirstLoginLocationState

    constructor(props: Readonly<Props & ResidentPagePropsSet>) {
        super(props)
        this.state = {
            mailAddress: '',
            mailAddressConfirm: '',
            registerMailButtonflg: true,
            fieldsError: {},
            duplicateError: false,
            isLoadCompleted: false,
        }
        const locationState = this.props.location.state
        // @ts-ignore
        this.firstLoginLocationState = (locationState) ? locationState.firstLoginLocationState : []

        if (!locationState) {
            window.location.href = `/resident/error`
            return
        }

        this.backLoginButtonClick = this.backLoginButtonClick.bind(this)
        this.registerMailButtonClick = this.registerMailButtonClick.bind(this)
        this.handleInputChange = this.handleInputChange.bind(this)
        this.updateRegisterMailButtonDisabled = this.updateRegisterMailButtonDisabled.bind(this)
    }

    componentDidMount(): void {
        this.setState({
            mailAddress: this.firstLoginLocationState.mailAddress ?? '',
            mailAddressConfirm: this.firstLoginLocationState.mailAddress ?? '',
            isLoadCompleted: true,
        }, () => {
            this.updateRegisterMailButtonDisabled()
        })
    }

    // 入力
    handleInputChange(event: React.ChangeEvent<HTMLInputElement>): void {
        let mailAddress: string = this.state.mailAddress
        let mailAddressConfirm: string = this.state.mailAddressConfirm

        // 入力項目
        switch (event.target.name) {
            case 'mailAddress':
                mailAddress = event.target.value
                break
            case 'mailAddressConfirm':
                mailAddressConfirm = event.target.value
                break
            default:
                break
        }

        this.setState({
            mailAddress: mailAddress,
            mailAddressConfirm: mailAddressConfirm,
        }, () => {
            this.updateRegisterMailButtonDisabled()
        })
    }

    updateRegisterMailButtonDisabled(): void {
        const {mailAddress, mailAddressConfirm} = this.state
        const registerMailButtonflg = (mailAddress === '' || mailAddressConfirm === '')

        this.setState({registerMailButtonflg: registerMailButtonflg})
    }

    // ログインページへ
    backLoginButtonClick(): void {
        this.props.navigate(this.firstLoginLocationState.referenceId
            ? `/guest/mypage?accessKey=${this.firstLoginLocationState.referenceId}`
            : `/resident/login`,
        )
    }

    // メールアドレスを登録する
    async registerMailButtonClick(): Promise<void> {
        await this.clearMessage()

        // 相関チェック
        if (this.state.mailAddress !== this.state.mailAddressConfirm) {
            this.setFieldErrorMessage('mailAddressConfirm', Messages.EOPCC0032.toString())
            return
        }
        await this.props.eventEmitter.showLoading()
        try {
            // トークン登録
            const registerTokenRequest: RegisterTokenFirstLoginRequest = {
                mailAddress: this.state.mailAddress,
                authenticationKey: this.firstLoginLocationState.authenticationKey,
                policyAgreeType: this.firstLoginLocationState.policyAgreeType,
                referrerId: this.firstLoginLocationState.firstLoginReferrerId,
                referenceId: this.firstLoginLocationState.referenceId,
                familyName: this.firstLoginLocationState.familyName,
                firstName: this.firstLoginLocationState.firstName,
                familyNameKana: this.firstLoginLocationState.familyNameKana,
                firstNameKana: this.firstLoginLocationState.firstNameKana,
            }
            const ret: Nullable<NatPostTokenFirstLogin> =
                await NatAsyncCallFunction(this.props.tokenRepo.registerTokenFirstLogin.bind(
                        this.props.tokenRepo, registerTokenRequest), this.props.navigate,
                    () => {
                        this.props.navigate(`/resident/error`, {
                            replace: true,
                            state: {
                                message: Messages.ESYCC0018.toString(),
                                nonDisplayBackBtnFlag: this.firstLoginLocationState.referenceId ? true : false,
                            },
                        })
                    })
            if (ret) {
                this.props.navigate(
                    `/resident/firstLoginMailSendComplete`,
                    {state: {firstLoginLocationState: this.firstLoginLocationState}},
                )
            }
        } catch (HttpError) {
            const errorResponseBody: Nullable<ErrorResponseBody> = (HttpError as BaseHttpError).responseBody
            if (errorResponseBody !== null) {
                errorResponseBody.requestItemErrors.forEach((item: RequestItemError) => {
                    if (item.fields) {
                        item.fields.forEach((field) => {
                            this.setFieldErrorMessage(field, item.message)
                        })
                    }
                    if (item.resultCode) {
                        this.setFieldErrorMessage(item.resultCode, item.message)
                    }
                })
                if (errorResponseBody.requestError !== null &&
                    errorResponseBody.requestError.messageId === 'EOPCC1013') {
                    this.setState({duplicateError: true})
                }
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    // メッセージ設定（フィールド）
    setFieldErrorMessage(field: string, message: string): void {
        if (field === 'mailAddress' || field === 'mailAddressConfirm') {
            let error: Error[] | undefined = this.state.fieldsError[field]
            if (error === undefined) {
                error = [{message: message, hasError: true}]
            } else {
                error.push({message: message, hasError: true})
            }

            this.setState(({fieldsError}) => (
                {
                    fieldsError: {
                        ...fieldsError,
                        [field]: error,
                    },
                }))
        }
    }

    // メッセージ取得（フィールド）
    getFieldErrorMessage(fieldId: Field): Nullable<ReactElement> {
        const field: Error[] | undefined = this.state.fieldsError[fieldId]
        if (field !== undefined) {
            return (
                <>
                    {field.map((error, index) => (
                        <FieldErrorLabel key={index}>
                            {error.message}
                        </FieldErrorLabel>
                    ))}
                </>
            )
        } else {
            return null
        }
    }

    // フィールドエラー状態取得
    getFieldErrorStatus(fieldId: Field): boolean {
        const field: Error[] | undefined = this.state.fieldsError[fieldId]
        return !!(field !== undefined && field[0] !== undefined && field[0].hasError)
    }

    // メッセージ取得（重複）
    getDuplicateErrorMessage(): Nullable<ReactElement> {

        if (this.state.duplicateError && this.firstLoginLocationState.policyAgreeType === AGREEMENT_TYPE.SUTEKI.value) {
            return (
                <DuplicateErrorLabel>
                    ご入力のメールアドレスは既に長谷工IDに登録がされております。<br/>
                    他のメールアドレスを入力していただくか、再度初めから操作していただき「長谷工ID連携」に同意していただいたうえで、利用していただくようにお願い致します。
                </DuplicateErrorLabel>
            )
        } else if (this.state.duplicateError) {
            return (
                <DuplicateErrorLabel>
                    ご入力のメールアドレスは既に長谷工IDに登録がされております。<br/>
                    <SmallPlainLinkStyledButton onClick={() => {
                        this.props.navigate(-1)
                    }}>
                        「長谷工IDをお持ちの方」
                    </SmallPlainLinkStyledButton>
                    より再度メールアドレス、パスワードの入力、ログインをお願い致します。<br/>
                    パスワードをお忘れの方は
                    <SmallPlainLinkStyledButton
                        onClick={() => {
                            window.open(HKConstants.CMN.OPC.FLP_FORGET_PASSWORD_MAIL_URL, '_blank')
                        }}>
                        「ブランシエラクラブ＿パスワード再設定」
                    </SmallPlainLinkStyledButton>
                    から再設定をお願い致します。
                </DuplicateErrorLabel>
            )
        } else {
            return null
        }
    }


    // メッセージクリア
    clearMessage(): void {
        this.setState({fieldsError: {}, duplicateError: false})
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }

        return (
            <>
                <NatStepComponent
                    dIspStepInfo={this.firstLoginLocationState.dIspStepInfo}
                    nowStep={Step.MAIL_ADDRESS_REGISTER}
                />
                <ContentsSubTitleWrapper>
                    <ContentsSubTitleInner>
                        メールアドレス登録
                    </ContentsSubTitleInner>
                </ContentsSubTitleWrapper>
                {this.getDuplicateErrorMessage()}
                <WideMainContainer>
                    <BlockSpacer height={'15px'}/>
                    素敵ネットにログインするにはメールアドレスの登録、パスワードの設定が必要になります。
                    <BlockSpacer height={'15px'}/>
                    <DisplayBlockDiv>
                        <DisplayItemInputLabelRequired>
                            <DisplayItemInputTitleRequired>メールアドレス</DisplayItemInputTitleRequired>
                            <DisplayItemTextInput
                                type="text"
                                name="mailAddress"
                                maxLength={100}
                                value={this.state.mailAddress}
                                placeholder={'メールアドレス'}
                                onChange={this.handleInputChange}
                                hasError={this.getFieldErrorStatus('mailAddress')}
                                autoFocus={true}
                            />
                            <Comment>例：mail@example.com （半角英数字）</Comment>
                        </DisplayItemInputLabelRequired>
                        {this.getFieldErrorMessage('mailAddress')}
                    </DisplayBlockDiv>
                    <DisplayBlockDiv>
                        <DisplayItemInputLabelRequired>
                            <DisplayItemInputTitleRequired>メールアドレス（確認用）</DisplayItemInputTitleRequired>
                            <DisplayItemTextInput
                                type="text"
                                name="mailAddressConfirm"
                                maxLength={100}
                                value={this.state.mailAddressConfirm}
                                placeholder={'メールアドレス（確認用）'}
                                onChange={this.handleInputChange}
                                hasError={this.getFieldErrorStatus('mailAddressConfirm')}
                            />
                            <Comment>※確認の為にもう一度ご入力下さい</Comment>
                        </DisplayItemInputLabelRequired>
                        {this.getFieldErrorMessage('mailAddressConfirm')}
                    </DisplayBlockDiv>
                    <Box fontSize={FontSize.Middle}>
                        <TxtBold>【注意事項】</TxtBold>
                        <Box ml={'15px'}>
                            <ListGridContainer>
                                <div>・</div>
                                <div>メールが届かない場合は、ご契約のプロバイダやメールソフトの設定などにより、受信ができない可能性がございます。</div>
                                <div>・</div>
                                <div>迷惑メールの設定・ドメイン指定受信をご確認ください。設定方法はご契約のプロバイダのWebサイトをご確認ください。</div>
                                <div>・</div>
                                <div>送信されるメール内に記述されているURLの有効期限は2時間です。</div>
                                {!this.firstLoginLocationState.referenceId &&
                                    <>
                                        <div>・</div>
                                        <div>2時間経過した場合は再度認証キーを入力してください。</div>
                                    </>
                                }
                                <div>・</div>
                                <div>yahooメール/gmail等のフリーメールアドレスでもご登録いただけます。
                                    スマートフォンをご利用のお客様でも、SMSにて受信するメールアドレスをご利用の方は、
                                    本登録メールが正しく表示されず、登録いただけませんのでご注意ください。
                                </div>
                            </ListGridContainer>
                        </Box>
                    </Box>
                    <BlockSpacer height={'20px'}/>
                </WideMainContainer>
                <BlockSpacer height={'2px'}/>
                <WideMainContainer>
                    <StyledExpansionPanel>
                        <StyledExpansionPanelSummary
                            expandIcon={<StyledExpandMoreIcon/>}
                            aria-controls="panel1a-content"
                            id="help-contactus-header"
                        >
                            <InfoName>メールが届かない場合</InfoName>
                        </StyledExpansionPanelSummary>
                        <StyledExpansionPanelDetails>
                            <StyledTypography>
                                <BlockSpacer height={'20px'}/>
                                <ListGridContainer>
                                    <div>・</div>
                                    <div>お使いのメールアドレスの受信設定をご確認ください。</div>
                                    <div>・</div>
                                    <div>@suteki.haseko.jpのドメインを受信できるように設定してください。</div>
                                    <div>・</div>
                                    <div>迷惑メールフォルダに届いていないかの確認をお願いします。</div>
                                    <div>・</div>
                                    <div>送信されるメール内に記述されているURLの有効期限は2時間です。
                                        {
                                            !this.firstLoginLocationState.referenceId && '2時間経過した場合は再度認証キーを入力してください。'
                                        }
                                    </div>
                                    <div>・</div>
                                    <div>受信設定により迷惑メールフォルダにもない場合がございますので
                                        その際は各プロバイダへお問い合わせください。
                                    </div>
                                    <div>・</div>
                                    {/* tslint:disable-next-line:max-line-length */}
                                    <div>お使いのメーラーによっては本登録用のURLが正しく表示されず、登録画面ではなくログイン画面が表示されてしまうようなことがございます。その場合はお手数ですが、URLをメモ帳アプリなどにコピーし、整形したうえでアドレスバーへコピーしていただく必要がございます。</div>
                                    <div>・</div>
                                    <div>メール送信済み（受信）の画面<br/>
                                        yahooメールなどをご利用の方で、メール受信フォルダにメールが見当たらない方は迷惑メールフォルダをご確認ください。
                                    </div>
                                </ListGridContainer>
                            </StyledTypography>
                        </StyledExpansionPanelDetails>
                    </StyledExpansionPanel>
                </WideMainContainer>
                <BlockSpacer height={'30px'}/>
                <PrimaryStyledButton
                    onClick={this.registerMailButtonClick}
                    disabled={this.state.registerMailButtonflg}>
                    メールアドレスを登録する
                </PrimaryStyledButton>
                <BlockSpacer height={'30px'}/>
                <CenterPlainLinkStyledButton onClick={this.backLoginButtonClick}>
                    {this.firstLoginLocationState.referenceId ? 'トップページへ戻る' : 'ログイン画面へ戻る'}
                </CenterPlainLinkStyledButton>
                <BlockSpacer height={'30px'}/>
            </>
        )
    }
}

export default createResidentPage(NatResidentFirstLoginMailAddressRegisterPage)

const DuplicateErrorLabel: StyledDiv = styled.div`
  margin: 5px 0 0 0;
  white-space: pre-wrap;
  word-wrap: break-word;
  color: ${Colors.Alert};
`

const StyledExpansionPanel = withStyles({
    root: {
        margin: '0',
        padding: '15px 0px',
        '&$expanded': {
            margin: '0',
        },
        boxShadow: 'initial',
    },
    expanded: {},
})(Accordion)


// タイトル
const StyledExpansionPanelSummary = withStyles({
    root: {
        padding: '0',
        minHeight: '0px',
        '&$expanded': {
            minHeight: '0px',
            margin: '0',
        },
    },
    content: {
        margin: '0',
        '&$expanded': {
            margin: '0',
        },
    },
    expandIcon: {
        marginRight: '0',
        padding: '0',
    },
    expanded: {
        minHeight: '0',
        margin: '0',
    },
})(AccordionSummary)


// お問い合わせ先情報
const StyledExpansionPanelDetails = withStyles({
    root: {
        padding: '0',
    },
})(AccordionDetails)


// アコーディオンアイコン
const StyledExpandMoreIcon = withStyles({
    root: {
        fontSize: '2.4rem',
        color: Colors.AccentDark,
    },
})(ExpandMoreIcon)

// テキストフォント
const StyledTypography = styled(Typography)`
  &.MuiTypography-body1 {
    font-family: 'Noto Sans JP';
    color: ${Colors.Body};
  }
`

const InfoName = styled.div`
  flex-grow: 1;
  text-align: start;
  position: relative;
  color: ${Colors.Body};
  margin-right: 15px;
`

const ListGridContainer = styled.div`
  display: grid;
  grid-template-columns: min-content auto;
  font-size: 　${FontSize.Middle}
`
